import { ResponseType } from 'types/response.d';
import { ResetPasswordRequest } from 'types/user.type';
import { post, put } from '../axios';

const url = `/v1/ext/user/reset-password`;

export const resetPassword = (request: ResetPasswordRequest): Promise<ResponseType<boolean>> =>
  post(`${url}`, request);

export const requestPhoneResetOtp = (
  request: ResetPasswordRequest
): Promise<ResponseType<boolean>> => post(`${url}/phone/otp/request`, request);

export const verifyPhoneResetOtp = (
  request: ResetPasswordRequest
): Promise<ResponseType<string>> => post(`${url}/phone/otp/verify`, request);

export const updatePassword = (request: ResetPasswordRequest): Promise<ResponseType<boolean>> =>
  put(`${url}/update-password`, request);
